import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import classnames from 'classnames'

import styles from './header.module.css'
import LogoImage from '../images/logo.png'

const Header = () => (
  <div className={classnames(styles.horizontal, styles.header)}>
    <div className={`${styles.horizontal} ${styles.fill}`}>
      <span>{moment().format('MM/DD/YYYY')}</span>
      <img className={styles.logo} src={LogoImage} alt="logo" />
      <div>
        COLLEGE <strong style={{ fontWeight: 500 }}>PULSE</strong> Report for{' '}
        <strong style={{ fontSize: '24px', marginLeft: 10, fontWeight: 600 }}>
          {' '}
          Dartmouth College
        </strong>
      </div>
    </div>
    {/*
      <h1 style={{ margin: 0 }}>
        <Link
          to="/"
          style={{
            color: 'white',
            textDecoration: 'none',
          }}
        >
          {siteTitle}
        </Link>
      </h1>
    */}
    <div className={styles.horizontal}>
      <a
        className={styles.link}
        href="https://blog.collegepulse.com"
        target="_blank"
        rel="noopener noreferrer"
      >
        Blog
      </a>
      <a className={styles.link} href="https://collegepulse.com">
        Login
      </a>
      <a
        className={`${styles.link} ${styles.borderedLink}`}
        href="https://bbuw.app.link/aQDnmdADAQ"
        target="_blank"
        rel="noopener noreferrer"
      >
        Download the App
      </a>
    </div>
  </div>
)

Header.propTypes = {
  siteTitle: PropTypes.string,
}

export default Header
